<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.name }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                  }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Code" label-for="id" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.id" placeholder="Enter code" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.id = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Description" label-for="name" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.name" placeholder="Enter description"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.name = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Reports" label-for="reports" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.reports" placeholder="Enter reports"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.reports = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Order" label-for="order" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.order" placeholder="Enter order"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.order = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Own Event" label-for="ownevent" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.ownevent" placeholder="Enter own event"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.ownevent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Show Event Detail" label-for="showeventdetail" label-cols="12">
                      <b-form-radio-group class="z-0" id="showeventdetail" v-model="item.showeventdetail" :options="[
                        { text: 'Yes', value: 'Y' },
                        { text: 'No', value: 'N' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="AMEX Code" label-for="amexcode" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.amexcode" placeholder="Enter AMEX code"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.amexcode = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Heads" label-for="heads" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.heads" placeholder="Enter heads"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.heads = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Column" label-for="column" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.column" placeholder="Enter column"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.column = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Sales N/L" label-for="salesnl" label-cols="12">
                      <treeselect instanceId="salesnl" type="number" v-model="item.salesnl" :clearable="true"
                        :options="nlcode_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Costs N/L" label-for="costsnl" label-cols="12">
                      <treeselect instanceId="costsnl" type="number" v-model="item.costsnl" :clearable="true"
                        :options="nlcode_options"></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Includes supplier name VATable" label-for="matchsuppliervat" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:160px; top:-13px">
                        <i id="matchsuppliervat_tooltip" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="matchsuppliervat_tooltip" triggers="hover" placement="top">Includes supplier
                        name VATable
                      </b-tooltip>
                      <b-form-textarea id="matchsuppliervat" v-model="item.matchsuppliervat"
                        placeholder="Includes supplier name VATable" rows="5" class="smalltextarea"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Includes supplier name NonVatable" label-for="matchsuppliernvat"
                      label-cols="12">
                      <b-input-group class="treeselect_all" style="left:180px; top:-13px">
                        <i id="matchsuppliernvat_tooltip" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="matchsuppliernvat_tooltip" triggers="hover" placement="top">Includes supplier
                        name NonVatable
                      </b-tooltip>
                      <b-form-textarea id="matchsuppliernvat" v-model="item.matchsuppliernvat"
                        placeholder="Includes supplier name NonVatable" rows="5"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
          </b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <!-- <b-button squared size="sm" variant="primary" @click="saveit" v-if="user.rolename == 'admin'">
                <i class="fa fa-check"></i>
                Save It
              </b-button> -->
              <b-button squared size="sm" variant="primary" @click="saveit" v-if="user.permissions.includes('setup_suppliertypes.admin')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Setup_SupplierTypeEdit",

  data() {
    return {
      busy: false,

      item: {
        id: null,
        name: null,
        reports: null,
        order: null,
        ownevent: null,
        showeventdetail: null,
        amexcode: null,
        heads: null,
        column: null,
        salesnl: null,
        costsnl: null,
        matchsuppliervat: null,
        matchsuppliernvat: null,
      },

      nlcode_options: [],
      options: {
        title: "Supplier Type",
        icon: "fa fa-bars",
      },
    };
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.busy = true;

      // try {
      //   const response = await this.$apollo.query({
      //     query: gql`
      //       query salesgroups {
      //         salesgroups {
      //           id
      //           label: id
      //         }
      //       }
      //     `,
      //   });
      //   this.salesgroups_options = response.data.salesgroups;
      // } catch (error) {
      // }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
        });
        this.nlcode_options = response.data.nlcodes;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliertypes($id: String) {
              suppliertypes(id: $id) {
                id
                name
                reports
                order
                ownevent
                showeventdetail
                amexcode
                heads
                column
                salesnl
                costsnl
                matchsuppliervat
                matchsuppliernvat
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.suppliertypes.length > 0) {
          this.item = response.data.suppliertypes[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation suppliertypes_save(
              $rows: [Suppliertype_input]
              $dateformat: String
            ) {
              suppliertypes_save(rows: $rows, dateformat: $dateformat) {
                id
                name
                reports
                order
                ownevent
                showeventdetail
                amexcode
                heads
                column
                salesnl
                costsnl
                matchsuppliervat
                matchsuppliernvat
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>